/* lib/ttkCompute.js — DERIVED-расчёты ТТК. Инвариант «LLM извлекает — код считает»:
   потери (% хол./% теп.), себестоимость строки/порции, FC%, КБЖУ на 100 г,
   allergens_auto — считаются ЗДЕСЬ из источников правды (брутто/нетто/выход +
   цены карточек), нигде не редактируются вручную.
   Чистые функции, без побочных эффектов и без импорта моков.
   ХЕНДОФФ → frontend/src/lib/ttkCompute.js (1:1; источник цен — lib/api). */

  const num = (v) => (v == null || v === '' || isNaN(Number(v)) ? null : Number(v));
  const round1 = (v) => (v == null ? null : Math.round(v * 10) / 10);
  const round = (v) => (v == null ? null : Math.round(v));

  // цена за грамм карточки сырья из current_price_brief (кг/л → /1000; штучные → null)
  function pricePerGram(card) {
    if (!card || !card.current_price_brief) return null;
    const a = num(card.current_price_brief.amount_rub);
    if (a == null) return null;
    const u = (card.current_price_brief.unit_label || '').toLowerCase();
    if (u === 'кг' || u === 'л') return a / 1000;
    return null; // пуч./дес./уп./шт. — без перевода в граммы
  }

  // % холодной обработки (зачистка): (брутто − нетто) / брутто
  function coldLossPct(row) {
    const b = num(row.amount_brutto_g), n = num(row.amount_netto_g);
    if (b == null || n == null || b <= 0) return null;
    return round1(((b - n) / b) * 100);
  }
  // % тепловой обработки (ужарка/уварка): (нетто − выход) / нетто
  function hotLossPct(row) {
    const n = num(row.amount_netto_g), w = num(row.weight_in_dish_g);
    if (n == null || w == null || n <= 0) return null;
    return round1(((n - w) / n) * 100);
  }

  // себестоимость одной строки (по брутто). cardsById / ttksById — словари
  function rowCost(row, cardsById, ttksById) {
    const b = num(row.amount_brutto_g);
    if (b == null) return null;
    if (row.target_kind === 'card') {
      const ppg = pricePerGram(cardsById[row.target_id]);
      return ppg == null ? null : ppg * b;
    }
    if (row.target_kind === 'ttk') {
      const t = ttksById[row.target_id];
      if (!t || t.cost_per_portion_rub == null || !t.output_g) return null;
      return (t.cost_per_portion_rub / t.output_g) * b; // цена за грамм п/ф
    }
    return null; // не привязана
  }

  // сводка себестоимости по всем строкам
  function costSummary(rows, cardsById, ttksById, output_g) {
    const bound = (rows || []).filter((r) => r.target_kind === 'card' || r.target_kind === 'ttk');
    if (!bound.length) return { total: null, status: 'missing', missing: (rows || []).length, per100g: null };
    let total = 0, missing = 0;
    bound.forEach((r) => {
      const c = rowCost(r, cardsById, ttksById);
      if (c == null) { missing++; } else { total += c; }
    });
    const unbound = (rows || []).length - bound.length;
    const allMissing = missing + unbound;
    let status = 'ok';
    if (missing === bound.length) status = 'missing';
    else if (allMissing > 0) status = 'partial';
    const out = num(output_g);
    return {
      total: status === 'missing' ? null : round(total),
      status,
      missing: allMissing,
      per100g: status === 'missing' || !out ? null : round((total / out) * 100),
    };
  }

  // FC% = себестоимость порции / цена продажи
  function foodCostPct(cost, price) {
    const c = num(cost), p = num(price);
    if (c == null || p == null || p <= 0) return null;
    return round1((c / p) * 100);
  }

  // КБЖУ на 100 г из «на порцию» и выхода
  function per100g(perPortion, output_g) {
    const out = num(output_g);
    if (!perPortion || !out) return null;
    const k = (v) => { const n = num(v); return n == null ? null : round1((n / out) * 100); };
    return {
      kcal: k(perPortion.kcal), protein: k(perPortion.protein),
      fat: k(perPortion.fat), carbs: k(perPortion.carbs),
    };
  }

  // allergens_auto: объединение аллергенов привязанных карточек/п-ф
  function autoAllergens(rows, cardAllergensById, ttksById) {
    const set = new Set();
    (rows || []).forEach((r) => {
      if (r.target_kind === 'card') {
        (cardAllergensById[r.target_id] || []).forEach((a) => set.add(a));
      } else if (r.target_kind === 'ttk') {
        const t = ttksById[r.target_id];
        (t && t.allergens || []).forEach((a) => set.add(a));
      }
    });
    return [...set];
  }

  // количество непривязанных строк
  function unboundCount(rows) {
    return (rows || []).filter((r) => r.target_kind !== 'card' && r.target_kind !== 'ttk').length;
  }
  function boundCount(rows) {
    return (rows || []).filter((r) => r.target_kind === 'card' || r.target_kind === 'ttk').length;
  }

  // полный пересчёт detail-объекта (после правки строк) — то, что отдал бы бэкенд
  function recompute(detail, ctx) {
    const cardsById = ctx.cardsById || {};
    const ttksById = ctx.ttksById || {};
    const cardAllergensById = ctx.cardAllergensById || {};
    const rows = (detail.ingredient_rows || []).map((r) => ({
      ...r,
      cold_loss_pct: coldLossPct(r),
      hot_loss_pct: hotLossPct(r),
      cost_rub: rowCost(r, cardsById, ttksById),
    }));
    const cs = costSummary(rows, cardsById, ttksById, detail.output_g);
    return {
      ingredient_rows: rows,
      cost_per_portion_rub: cs.total,
      cost_per_100g_rub: cs.per100g,
      cost_status: cs.status,
      cost_missing_count: cs.missing,
      fc_pct: foodCostPct(cs.total, detail.selling_price_rub),
      kbju_per_100g: per100g(detail.kbju_per_portion, detail.output_g),
      allergens_auto: autoAllergens(rows, cardAllergensById, ttksById),
    };
  }

  window.ttkCompute = {
    pricePerGram, coldLossPct, hotLossPct, rowCost, costSummary,
    foodCostPct, per100g, autoAllergens, unboundCount, boundCount, recompute,
  };

const __ex_ttkCompute = window.ttkCompute; export { __ex_ttkCompute as ttkCompute };
